import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import CircularProgressBar from './CircularProgressBar';

const StatusGraph = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const [userName, setUserName] = useState('');
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        // Get the userName and userId from location.state if available, otherwise from localStorage
        const storedUser = JSON.parse(localStorage.getItem('user'));  // Assuming 'user' is stored in localStorage

        const userNameFromLocation = location.state?.userName || storedUser?.userName || '';
        const userIdFromLocation = location.state?.userId || storedUser?.userId || null;

        setUserName(userNameFromLocation);
        setUserId(userIdFromLocation);
    }, [location]);  // Re-run the effect when the location changes

    const [applicationsData, setApplicationsData] = useState([]);

    useEffect(() => {
        if (userId) {
            fetchApplicationsData(userId);
        }
    }, [userId]);

    const fetchApplicationsData = async (userId) => {
        try {
            const response = await axios.get(`${BASE_API_URL}/countByDate`, {
                params: { userId },
            });
            setApplicationsData(response.data);
        } catch (error) {
            console.error('Error fetching application data:', error);
        }
    };

    const options = {
        chart: {
            id: 'chart1',
            type: 'line',
            zoom: { enabled: true },
        },
        xaxis: {
            type: 'datetime',
            categories: applicationsData.map((data) => new Date(data.date).toISOString()),
        },
        yaxis: {
            min: 0,
            max: Math.min(50, Math.max(...applicationsData.map((data) => data.count))+ 10), // Calculate max dynamically
            tickAmount: 10,
            labels: {
                formatter: (val) => parseInt(val, 10),
            },
        },
        series: [
            {
                name: 'Applications',
                data: applicationsData.map((data) => data.count),
            },
        ],
    };
    

    return (
        <Row style={{ height: "fit-content" }} >
            {/* <Col lg={6} style={{ paddingLeft: '25px' }}>
                <Card className="mb-4"> {/* Light purple 
                    <Card.Header className="bg-light text-center" style={{ height: '30px', width: '100%' }}>
                        <Card.Title as="h4" className="mb-3">Applications per Day</Card.Title>
                    </Card.Header>
                    <Card.Body className="pb-0">
                        <div className="chart-card">
                            <Chart
                                options={options}
                                series={options.series}
                                type={options.chart.type}
                                height="350"
                                width="100%"
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col> */}
             <Col md={6} xs={12} className="mb-4">
                <Card body className="h-100">
                <Card.Title as="h4" className="mb-3 text-center">Applications per Day</Card.Title>
                    <Chart options={options} series={options.series} type={options.chart.type} />
                </Card>.
            </Col>
            <Col md={6} xs={12} className="mb-4">
                {/* <div style={{ height: "320px" }}>
                  <svg viewBox="0 0 400 400" width="100%" height="100%">
                    <VictoryPie
                      standalone={false}
                      animate={{ duration: 1000 }}
                      width={400}
                      height={400}
                      data={state.data}
                      innerRadius={120}
                      cornerRadius={25}
                      labels={() => null}
                      style={{
                        data: {
                          fill: ({ datum }) => {
                            const color = datum.y > 30 ? "green" : "red";
                            return datum.x === 1 ? color : "transparent";
                          }
                        }
                      }}
                    />
            
                    <VictoryAnimation duration={1000} data={state}>
                      {(newProps) => (
                        <VictoryLabel
                          x={200}
                          y={200}
                          textAnchor="middle"
                          verticalAnchor="middle"
                          text={`${Math.round(newProps.percent)}%`}
                          style={{ fontSize: 45 }}
                        />
                      )}
                    </VictoryAnimation>
                  </svg>
                </div> */}
                <CircularProgressBar userId={userId} userName={userName} />
            </Col>
           
        </Row>
    );
};

export default StatusGraph;
